import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { Layout, WizardFooter, Card, MainLoader, Heading, ActionButton, ExternalLink, FormFieldInputNew, useForm, Text } from "@netapp/bxp-design-system-react";
import styles from "./NoOrgDialog.module.scss";
import { setItemAnon } from "utils/localstorage";
import * as yup from 'yup';
import { SparksIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import { appComponents as i18nNamespace } from "../../../i18n/namespace";
import { useTranslation } from "react-i18next";

const useorgFormSchema= (t) => {
    return  yup.object().shape({
    orgName: yup
        .string()
        .matches(
            /^.{1,300}$/,
            t("enter_name"),
          )
        .required(t("organization_name_required"))
});
}

export default React.memo(() => {
    const {isReloading, isCreatingAccount, userCompany, name} = useSelector((state) => ({
                                                                            isReloading: state.app.isReloading,
                                                                            isCreatingAccount: state.tenancy?.creatingAccount,
                                                                            userCompany: state.tenancy?.user?.company,
                                                                            name: state.auth.firstName
                                                                            }));
    const dispatch = useDispatch();
    const [isPending, setIsPending] = useState(true);
    const {t} = useTranslation(i18nNamespace);
    const orgFormSchema = useorgFormSchema(t);
    const form = useForm({orgName: ''}, orgFormSchema);
    const { isValid, handleFormSubmit, formState } = form;

    useEffect(() => {
        if (userCompany) {
            form.handleFormChange(userCompany, {name: 'orgName'});
        }
        setIsPending(false);
    }, [userCompany]);

    const createOrganization = () => {
        setItemAnon({itemKey: `dontShowNewBlue`}, true)
        dispatch({
            type: 'TENANCYV4:CREATE-ORGANIZATION',
            payload: {
                organizationName: formState.orgName,
                resourceType: "organization",
                resourceClass: "hierarchy",
                version: "1.0",
                type : "application/vnd.netapp.bxp.resource",
            }
        });
    };

    if(isReloading) {
        return <MainLoader/>
    }

    return <>
        <Layout.Page className={styles.base}>
            <Layout.Content>
                <Layout.Container>
                    <Layout.Grid centerContent>
                        <Layout.GridItem lg={6} style={{paddingTop: '50px'}}>
                            <Card className={styles.cardBase}>
                                <div style={{position: 'relative'}}>
                                    <SparksIcon style={{position: 'absolute', right: '-215px', top: '-120px'}} width="400" height="300"/>
                                </div>
                                <Heading color="text-title" level="20">{t("welcome")} {name},</Heading>
                                <br/><br/>
                                <Text bold level="16">{t("create_organization")}</Text>
                                <br/>
                                <Text level="14">{t("top_level_element")}</Text>
                                <br/>
                                <Text level="14">{t("join_account")}</Text>
                                <br/>
                                <ExternalLink variant="text" href="http://google.com" includeArrow={true}>{t("learn_more_about_organizations")}</ExternalLink>
                                <br/><br/><br/>
                                <FormFieldInputNew
                                    name="orgName"
                                    label={t("organization_name")}
                                    disabled={isCreatingAccount}
                                    form={form}
                                    autoComplete="off"
                                    pending={isPending}
                                />
                                <br/>
                                <Layout.Container className={styles.infoSection}>
                                    <Text level="14">{t("enable_key_workflows")}</Text>
                                    <br/>
                                    <ExternalLink variant="text" onClick={() => dispatch({
                                            type: "SUPPORT:ADD-NSS-OPEN-POPOVER"
                                            })} style={{cursor: 'pointer'}} includeArrow={false}>{t("netapp_support_site_account")}</ExternalLink>
                                </Layout.Container>
                            </Card>
                        </Layout.GridItem>
                    </Layout.Grid>
                </Layout.Container>
            </Layout.Content>
            <WizardFooter>
                <ActionButton disabled={!isValid} onClick={handleFormSubmit(createOrganization)} isSubmitting={isCreatingAccount}>{t("create")}</ActionButton>
            </WizardFooter>
        </Layout.Page>
    </>
})